import { useEffect, useState } from 'react';

export function useCreatePreview(subject, mailer_content, tone, variability, subject_variability, campaign, prompt_inject, language) {
  const [preview, setPreview] = useState();
  useEffect(() => {
    const doFetch = async () => {
      const fd = new FormData();
      fd.append('tone', tone);
      fd.append('variability', variability);
      fd.append('subject_variability', subject_variability);
      fd.append('mailer_content', mailer_content);
      fd.append('prompt_inject', prompt_inject);
      fd.append('subject', subject);
      if (language) {
        fd.append('language', language);
      }
      if (campaign) {
        fd.append('campaign_id', campaign._id);
      }
      const d = await fetch(`/api/v1/campaign/preview`, {method: 'POST', body: fd});
      const data = await d.json();
      // Note - this is only the preview ID. We will need to poll for its contents.
      setPreview(data['preview']);
    };
    doFetch();
    // eslint-disable-next-line
  }, []);
  return preview;
}
